import React from "react";
import Section from "@/components/ui/section";
import KnowMore from "@/components/ui/know-more";
import Image from "next/image";
import dynamic from "next/dynamic";
const ReactPlayer = dynamic(() => import("react-player/lazy"));
export default function StoriesIndonesia() {
  return (
    <Section className="bg-[#F5F9FC]" variant="flat">
      <div className="lg:flex-row flex-col flex justify-center items-center lg:gap-12 gap-6 w-full mx-auto">
        <div className="flex flex-col w-full gap-2 h-full justify-center">
          <h2 className="text-darkBlue">
            Stories of climate-affected internal migrants from Indonesia
          </h2>
        </div>
        <div className="flex flex-col gap-2">
          <div className="lg:w-[500px] md:h-[350px] w-full h-[200px] shrink-0 rounded-2xl overflow-hidden">
            <ReactPlayer
              url={"https://youtu.be/bGRWH7AM9ZY"}
              className={`overflow-hidden bg-body object-cover [&>video]:object-cover rounded-xl`}
              playing={false}
              loop={false}
              // light={card?.image}
              // playIcon={<Overlay card={card} handlePlaying={handlePlaying} />}
              playsinline={true}
              width="100%"
              height="100%"
              controls={true}
              muted={true}
            />
          </div>
          <p className="text-center lg:text-lg text-darkBlue font-medium">
            Rising Above Waters: A Migrant&apos;s Pursuit to Stability
          </p>
        </div>
      </div>
    </Section>
  );
}
